import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from '../Sidebar/Sidebar';
import BottomNav from '../BottomNav/BottomNav';
import './AppLayout.css';

const AppLayout = () => {
    const location = useLocation();

    const getHeaderHeight = () => {
        const path = location.pathname;
        if (path === '/dashboard' || path === '/admin') {
            return '240px'; // Tall header for overlap pages
        }
        return '140px'; // Shorter header for other pages
    };

    return (
        <div className="app-layout">
            <header className="brand-header" style={{ height: getHeaderHeight() }}>
                <h1 className="brand-title">PE Wallet</h1>
            </header>
            <Sidebar />
            <main className="main-content" >
                <div className="content-container">
                    <div className="layout-main">
                        <Outlet />
                    </div>
                </div>
            </main>
            <BottomNav />
        </div>
    );
};

export default AppLayout;
